// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import ldartEntity from './entities/ldart.json';
import ldartMenu from '../pages/ldart/menu.json';
import ldartFullForm from '../pages/ldart/forms/full.json';
import ldartContextForm from '../pages/ldart/forms/context.json';
import ldartMiniForm from '../pages/ldart/forms/mini.json';
import ldartLookupForm from '../pages/ldart/forms/lookup.json';
import ldartTableView from '../pages/ldart/views/table.json';
import ldartStagesView from '../pages/ldart/views/stages.json';
import ldartCardsView from '../pages/ldart/views/cards.json';
import ldartInlineView from '../pages/ldart/views/inline.json';
import ldartBacklogView from '../pages/ldart/views/backlog.json';
import ldartSplitView from '../pages/ldart/views/split.json';
import ldartCalendarView from '../pages/ldart/views/calendar.json';
import ldartDashboardView from '../pages/ldart/views/dashboard.json';

/** Тип запису «Стаття» зі сторінками пакета: меню, форми та подання з pages/ldart/. */
export const ldartDefinition: IRecordTypeDefinition = {
  ...ldartEntity,
  views: assembleViewSet({
      table: ldartTableView,
      stages: ldartStagesView,
      cards: ldartCardsView,
      inline: ldartInlineView,
      backlog: ldartBacklogView,
      split: ldartSplitView,
      calendar: ldartCalendarView,
      dashboard: ldartDashboardView,
  }),
  form: ldartFullForm,
  forms: { full: ldartFullForm, context: ldartContextForm, mini: ldartMiniForm, lookup: ldartLookupForm },
  menu: ldartMenu,
} as IRecordTypeDefinition;
